import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import classNames from 'classnames';

import * as Types from 'types';

import { newPlaylist, translatedPlaylistName } from 'features/playlists/helpers';
import { setPlaylists, setCurrentPlaylist } from 'features/playlists/actions';
import { SidebarWidget } from 'playlists/components/SidebarWidget';
import { SidebarMasterPlaylistTip } from 'playlists/components/SidebarMasterPlaylistTip';

import { useCurrentUser } from 'hooks/useCurrentUser';

type Props = {
  playlistId?: string;
  playlists: Types.Playlist[];
};

export const PlaylistList: React.FC<Props> = ({ playlists, playlistId }) => {
  const [isOpen, setOpen] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useCurrentUser();
  const activePlaylist = playlists.find((item) => item.id === playlistId);

  const createNewPlaylist = () => {
    const playlist = newPlaylist({ name: 'New Playlist' });
    dispatch(setPlaylists([playlist]));
    dispatch(setCurrentPlaylist(playlist));
    history.push(Routes.edit_vault_playlist_path(playlist.id));
    setOpen(false);
  };

  return (
    <>
      <SidebarWidget className='sidebar-widget--playlist-list'>
        <div
          className={classNames('sidebar-navigation', {
            'sidebar-navigation--open ': isOpen,
          })}
        >
          <div
            onClick={() => setOpen(!isOpen)}
            className='sidebar-navigation__mobile-dropdown bg-dark-gray'
          >
            Choose playlist...
            <div
              className={`sidebar-navigation__expand icon-down icon-flip ${
                isOpen ? 'icon-flip--open' : ''
              }`}
            />
          </div>
          <ul className='sidebar-navigation_list'>
            {playlists.map((playlist) => (
              <li
                key={playlist.id}
                className={classNames('sidebar-navigation__item', {
                  'sidebar-navigation__item--active': playlistId === playlist.id,
                  'sidebar-navigation__item--icon icon-vault-alternative':
                    playlist.type === 'Master',
                  'sidebar-navigation__item--icon icon-stream':
                    playlist.public && playlist.userId !== user?.id,
                })}
              >
                <Link onClick={() => setOpen(false)} to={Routes.vault_playlist_path(playlist.id)}>
                  {translatedPlaylistName(playlist)}
                </Link>
              </li>
            ))}
            <li className='sidebar-navigation__item mt-1'>
              <button
                className='btn btn--border-light btn--border-vault btn--new-playlist'
                onClick={createNewPlaylist}
              >
                New Playlist
              </button>
            </li>
          </ul>
        </div>
      </SidebarWidget>
      {activePlaylist?.type === 'Master' ? <SidebarMasterPlaylistTip /> : null}
    </>
  );
};
